import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      userSelect: 'none',
      color: palette.text.white,
      background: palette.common.primaryBlue,
      fontWeight: 500,
      fontSize: '0.875rem',
      padding: '15px',
      borderRadius: palette.borderRadius.default
    },
    text: {
      margin: '0'
    },
    position: {
      margin: '0',
      fontWeight: 700,
      marginTop: '5px',
      fontSize: '1.5rem'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
